import { Component, computed, inject, signal } from '@angular/core';
import { DroplistItem, DroplistWidget } from '@eforall/dashboard';
import { StaticDataService } from 'services';
import { AddDashboardDialogService } from '../add-dashboard.dialog.service';
import { getDatasetItems } from './get-dataset-items';



@Component({
	selector: 'add-dashboard-step-1',
	standalone: true,
	imports: [DroplistWidget],
	templateUrl: './add-dashboard-step-1.part.html',
	styleUrl: './add-dashboard-step-1.part.scss',
})

export class AddDashboardStep1Part {

	private service = inject(AddDashboardDialogService);
	private staticData = inject(StaticDataService);

	public readonly datasetItems = computed(() => { return getDatasetItems(this.staticData); });

	private _selectedDatasetItem = signal<DroplistItem<unknown, number> | undefined>(undefined);
	public selectedDatasetItem = this._selectedDatasetItem.asReadonly();

	public onDatasetChange(item: DroplistItem<unknown, number> | undefined) {
		if (item) this._selectedDatasetItem.set(item);
	}


	public selectDataset() {
		const item = this.selectedDatasetItem();
		if (item == undefined) return;
		this.service.setDatasetId(item.uniqueId);
	}

}